import React, { useState } from 'react'
import _, { isNil } from 'lodash'
import moment from 'moment'
import {
  Div, Icon, Button, H4, SmallText, P, Input, TextLink,
} from 'konsys-ui'
import numeral from 'numeral'
import {
  message, Row, Col, Select, DatePicker, Popover,
} from 'antd'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { Trash, Trash2 } from 'lucide-react'
import { CREATE_PURCHASE_ORDER, UPDATE_PURCHASE_ORDER } from '../../../constants/graph/mutation'
import {
  PURCHASEORDER, PURCHASEORDERS, SUPPLIERS, INVENTORIESPO, LOWINVENTORIESPO, PURCHASE_REQUISITION_LIST_FOR_PO, WAREHOUSES,
} from '../../../constants/graph/query'
import { detailMode } from '../constants'
import { verifyFields, checkFloat, checkInt } from '../../../utils/util-services'
import {
  TextareaWithLabel, FullPageContainer, Divider, InputWithLabel, SelectWithLabel, GroupRowSelect, SummaryPrice, Uploader,
} from '../../../components/common'
import history from '../../../history'
import { theme } from '../../../styles/_variables'

const discountTypeValue = {
  percent: 'PERCENT',
  value: 'BAHT',
}

const supplierPaymentType = ['CREDIT', 'CASH']

const InputRow = (props) => {
  const totalPrice = _.isEmpty(props.data) ? 0 : (props.data.quantity * props.data.buyPrice) - (props.data.quantity * props.data.discount)
  // const vat = props.data.isVat ? totalPrice * (parseFloat(props.data.vat, 10) / 100) : 0
  // const vatOptionList = fixItemTax.map(v => ({ text: `${v} %`, value: v }))
  return (
    <Div display='flex' alignItems='center' justifyContent='space-between' {...props}>
      <Trash2 className='cursor-pointer text-gray-500' onClick={() => props.onDelete && props.onDelete()} />
      <Div width='100%' display='flex' alignItems='center'>
        <P style={{ width: '38.2%' }} margin='0 40px 0 0'>{props.data.sku} {props.data.productName} {props.data.packName} {props.data.brand}</P>
        {
          // <Input
          //   id={props.data.sku}
          //   rule={{ type: 'date' }}
          //   state='default'
          //   width='15%'
          //   margin='0 40px 0 0'
          //   value={moment(props.data.expectedReceivedDate).format('DDMMYY')}
          //   onChange={date => props.onChange(date, 'expectedReceivedDate', 'date')}
          // />
        }
        <Input
          defaultValue={_.isNaN(props.data.quantity) ? '0' : `${props.data.quantity}`}
          onChange={(e) => {
            props.onChange(e.target.value < 0 ? 0 : e.target.value, 'quantity', 'number')
          }}
          onKeyDown={(e) => {
            if (!checkFloat(e)) {
              e.preventDefault()
            }
          }}
          width='12%'
          margin='0 24px 0 0'
          state='default'
          rule={{ type: 'float' }}
        />
        {
          // !_.isUndefined(props.data.salesPrice)
          //   ? <Popover content={`ไม่เกินราคาซื้อ: ${props.data.salesPrice}`}>
          <Input
            defaultValue={`${props.data.buyPrice}`}
            width='13%'
            margin='0 24px 0 0'
            rule={{ type: 'float' }}
            state='default'
            onChange={e => props.onChange(e.target.value < 0 ? 0 : e.target.value, 'buyPrice', 'number')}
            onKeyDown={(e) => {
              if (!checkFloat(e)) {
                e.preventDefault()
              }
            }}
          />
        }
        <Input
          defaultValue={`${props.data.discount}`}
          width='13%'
          margin='0 24px 0 0'
          rule={{ type: 'float' }}
          state='default'
          onChange={e => props.onChange(e.target.value < 0 ? 0 : e.target.value, 'discount', 'number')}
          onKeyDown={(e) => {
            if (!checkFloat(e)) {
              e.preventDefault()
            }
          }}
        />
        {
          // <Select
          //   defaultValue={PaymentVatType[props.data.isVat ? 1 : 0].value}
          //   style={{ width: '10%', margin: '0 8px 0 0' }}
          //   options={PaymentVatType}
          //   onChange={value => props.onChange(value === PaymentVatType[1].value, 'isVat', 'text')}
          // />
          // <Select
          //   disabled={!props.data.isVat}
          //   style={{ width: '7%', margin: '0 24px 0 0' }}
          //   value={!_.isNull(props.data.vat) && _.find(vatOptionList, d => d.value === parseFloat(props.data.vat)).value}
          //   options={vatOptionList}
          // />
          // <P textAlign='right' style={{ flexGrow: 1 }} margin='0 24px 0 0'>{numeral(vat).format('0,0.00')}</P>
        }
        <P textAlign='right' style={{ flexGrow: 1 }}>{numeral(totalPrice).format('0,0.00')}</P>
      </Div>
    </Div>
  )
}

const Render = ({
  isCreateMode, infoData, mutationLoading, doAction, props,
}) => {
  const [mutationVariables, setMutationVariables] = useState(isCreateMode ? { vat: 0 } : {
    warehouseCode: infoData.findWarehouse.data.warehouseCode,
    warehouseName: infoData.findWarehouse.data.warehouseName,
    vat: infoData.vatType === 'VAT_7' ? 7 : 0,
  })

  const {
    loading: supplierLoading,
    data: supplierData,
    refetch: supplierRefetch,
  } = useQuery(SUPPLIERS)

  const {
    data: inventoryData,
    refetch: inventoryRefetch,
  } = useQuery(INVENTORIESPO, {
    variables: {
      supplierId: mutationVariables?.supplierId,
    },
    skip: isNil(mutationVariables?.supplierId),
  })

  const {
    data: lowInventoryData,
    refetch: lowInventoryRefetch,
  } = useQuery(LOWINVENTORIESPO, {
    variables: {
      supplierId: mutationVariables?.supplierId,
    },
    skip: isNil(mutationVariables?.supplierId),
  })

  const {
    loading: warehouseLoading,
    data: warehouseData,
  } = useQuery(WAREHOUSES)

  const {
    data: purchaseRequisitionData,
    refetch: purchaseRequisitionRefetch,
  } = useQuery(PURCHASE_REQUISITION_LIST_FOR_PO, {
    variables: {
      status: 'ALL',
      supplierId: mutationVariables?.supplierId,
    },
    skip: isNil(mutationVariables?.supplierId),
  })

  const [selectedItemEmptyList, setSelectedItemEmptyList] = useState([])
  const [selectedItemPRList, setSelectedItemPRList] = useState([])
  const [shippingCost, setShippingCost] = useState(0)
  const [searchPR, setSearchPR] = useState()
  const [searchInventory, setSearchInventory] = useState()
  const [fileList, setFileList] = useState([])
  const [existFileList, setExistFileList] = useState([]) // to change
  const [discountType] = useState(discountTypeValue.value)

  const onInputRowChange = (type, value, key, valueType, index) => {
    const newArray = type === 'pr' ? [...selectedItemPRList] : [...selectedItemEmptyList]
    newArray[index][key] = valueType === 'date' ? moment(value, 'DDMMYY', 'Asia/Bangkok') : valueType === 'number' ? value ? parseFloat(value, 10) : 0 : value
    if (type === 'pr') {
      setSelectedItemPRList(newArray)
    } else {
      setSelectedItemEmptyList(newArray)
    }
  }

  const onInputRowDelete = (type, index) => {
    const newArray = type === 'pr' ? [...selectedItemPRList] : [...selectedItemEmptyList]
    _.remove(newArray, (v, i) => i === index)
    if (type === 'pr') {
      setSelectedItemPRList(newArray)
    } else {
      setSelectedItemEmptyList(newArray)
    }
  }

  const rowRenderData = (v, type, prDetail) => {
    const key = 'inventoryOption'
    const inventoryOptions = type === 'pr' ? v.Items.map(u => u.InventoryOption) : v.inventoryOptions
    const variantList = !_.isEmpty(inventoryOptions) && _.isArray(inventoryOptions) && inventoryOptions.map((o, i) => (
      {
        inventoryId: type === 'pr' ? o.inventory.id : v.id,
        inventoryOptionId: type === 'pr' ? o.id : o.id,
        sku: type === 'pr' ? o.inventory.sku : v.sku,
        quantity: type === 'pr' ? v.Items[i].quantity - v.Items[i].orderedQuantity : 1,
        buyPrice: o.buyPrice || 0,
        isVat: type === 'pr' ? o.isVat : v.inventoryOptions.isVat,
        vat: type === 'pr' ? o.vat : v.inventoryOptions.vat,
        id: type === 'pr' ? v.id : null,
        prNumber: type === 'pr' ? prDetail.refId : null,
        prItemId: type === 'pr' ? v.Items[i].id : null,
        discount: 0,
        productName: type === 'pr' ? o.inventory.productName : v.productName,
        brand: type === 'pr' ? o.inventory.brand : v.brand,
        name: type === 'pr' ? o.inventory.productName : o,
      }
    ))

    return {
      header: type !== 'pr' ? [] : [
        {
          value: type === 'pr' ? `${prDetail.refId}` : v.id,
          checked: type === 'pr' ? _.isEmpty(_.differenceBy(variantList, selectedItemPRList, 'id')) : _.isEmpty(_.differenceBy(variantList, selectedItemEmptyList, 'sku')),
          onChange: (e) => {
            if (e.target.checked) {
              if (type === 'pr' ? v.Items.length > 0 : v[key].length > 0) {
                const newList = type === 'pr' ? _.concat(...selectedItemPRList, variantList) : _.concat(...selectedItemEmptyList, variantList)
                if (type === 'pr') {
                  setSelectedItemPRList(newList)
                } else {
                  setSelectedItemEmptyList(newList)
                }
              }
            } else {
              const newList = type === 'pr' ? [...selectedItemPRList] : [...selectedItemEmptyList]
              inventoryOptions.forEach((t, i) => {
                _.remove(newList, (o) => {
                  if (type === 'pr') {
                    return o.inventoryId === t.inventory.id && o.id === v.id
                  }
                  return o.inventoryId === v.id
                })
              })
              if (type === 'pr') {
                setSelectedItemPRList(newList)
              } else {
                setSelectedItemEmptyList(newList)
              }
            }
          },
          data: [
            {
              title: { text: type === 'pr' ? `เลขใบ PR ${prDetail.refId}` : 'รหัสสินค้า' },
              content: { text: type === 'pr' && !_.isUndefined(prDetail.refId) ? prDetail.refId : v.sku },
            },
          ],
        },
      ], // end-header
      items: !_.isEmpty(inventoryOptions) ? inventoryOptions.map((d, i) => {
        if (!_.isEmpty(d)) {
          const {
            totalStock, soldStock, tobeStocked, preordered,
          } = d
          const minimumStock = d.minimumStock ? d.minimumStock : 0
          const amountStock = _.find(d.stockLocation, o => o.warehouse.warehouseCode === '00001').quantity
          return (
            {
              id: type === 'pr' ? `${v.id} ${d.inventory.sku}` : v.sku,
              value: type === 'pr' ? `${v.id}  ${d.inventory.sku}` : v.sku,
              name: type === 'pr' ? `${v.id}  ${d.inventory.sku}` : v.sku,
              checked: !_.isEmpty(_.find(type === 'pr' ? selectedItemPRList : selectedItemEmptyList, (o) => {
                if (type === 'pr') {
                  return o.sku === d.inventory.sku && o.id === v.id
                }
                return o.sku === v.sku
              })),
              onChange: (e) => {
                if (e.target.checked) {
                  if (_.isEmpty(_.find(selectedItemEmptyList, (o) => {
                    if (type === 'pr') {
                      return o.sku === d.inventory.sku && o.id === v.id
                    }
                    return o.sku === v.sku
                  }))) {
                    const newList = type === 'pr' ? [...selectedItemPRList] : [...selectedItemEmptyList]
                    if (type === 'pr') {
                      newList.push(_.find(variantList, dd => dd.inventoryId === d.inventory.id))
                      setSelectedItemPRList(newList)
                    } else {
                      newList.push(_.find(variantList, dd => dd.inventoryId === v.id))
                      setSelectedItemEmptyList(newList)
                    }
                  }
                } else {
                  const newList = type === 'pr' ? [...selectedItemPRList] : [...selectedItemEmptyList]
                  _.remove(newList, (o) => {
                    if (type === 'pr') {
                      return o.inventoryId === d.inventory.id && o.id === v.id
                    }
                    return o.inventoryId === v.id
                  })
                  if (type === 'pr') {
                    setSelectedItemPRList(newList)
                  } else {
                    setSelectedItemEmptyList(newList)
                  }
                }
              },
              data: [
                {
                  title: { text: 'รหัสสินค้า' },
                  content: {
                    text: type === 'pr' ? d.inventory.sku : v.sku,
                    style: { minWidth: '130px' },
                  },
                },
                {
                  title: { text: 'ชื่อ' },
                  content: {
                    text: type === 'pr' ? d.inventory.productName : v.productName,
                    style: { width: '100px', wordBreak: 'break-all' },
                  },
                  margin: '0 16px 0 0',
                },
                {
                  title: { text: 'ยี่ห้อ' },
                  content: {
                    text: type === 'pr' ? d.inventory ? d.inventory.brand : '-' : v.brand,
                    style: { width: '80px', wordBreak: 'break-all' },
                  },
                  margin: '0 72px 0 0',
                },
                {
                  title: { text: type === 'pr' ? 'จำนวนรอสั่งซื้อ' : 'สินค้าขั้นต่ำในคลัง' },
                  content: {
                    text: type === 'pr' ? `${v.Items[i].quantity - v.Items[i].orderedQuantity} ${d.inventory.unit || 'ชิ้น'}` : `${minimumStock} ${v.unit || 'ชิ้น'}`,
                    color: theme.color.black,
                  },
                },
                {
                  title: { text: 'จำนวนสินค้า' },
                  content: { text: `${amountStock || 0} ${type === 'pr' ? (d.inventory.unit || 'ชิ้น') : (v.unit || 'ชิ้น')}` },
                },
              ],
            }
          )
        }
        return null
      }) : [],
    }
  }

  const almostEmptyList = (!_.isEmpty(lowInventoryData)) ? lowInventoryData?.lowInventoryListforPO?.data?.list?.map(v => rowRenderData(v, 'almostEmpty')) : []
  const otherList = (!_.isEmpty(inventoryData)) ? inventoryData.normalInventoryListforPO.data.list.map(v => rowRenderData(v)) : []
  const prList = _.isEmpty(purchaseRequisitionData)
    ? []
    : _.flattenDeep(purchaseRequisitionData.PurchaseRequestListInPO.lists.map(v => (
      rowRenderData(v, 'pr', { refId: v.refId })
    )))

  return (
    <Div display='flex' flexDirection='column' padding='0 60px'>
      <SmallText margin='0 0 16px' bold>บริษัท *</SmallText>
      <Select
        style={{ width: '35%' }}
        onChange={e => setMutationVariables({
          ...mutationVariables,
          companyType: e,
        })}
      >
        <Select.Option value='PADOONGRICH'>บริษัท ผดุงฤทธิ์ขนส่ง จำกัด</Select.Option>
        <Select.Option value='TRANSPORT'>บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด</Select.Option>
      </Select>
      <Divider margin='40px 0' />
      <SmallText bold>Supplier *</SmallText>
      <Row type='flex' gutter={16} align='middle' style={{ margin: '16px -8px 0 -8px' }}>
        <Col span={24}>
          {
            (!supplierLoading || !_.isEmpty(supplierData))
            && <Select
              showSearch
              style={{ width: '100%' }}
              loading={supplierLoading}
              filterOption={(input, option) => option.props.name.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              onSelect={(e) => {
                const supplier = supplierData?.supplierList?.data?.list?.find(s => s.id === e)
                setMutationVariables({
                  ...mutationVariables,
                  supplierId: e,
                  vat: supplier.isVat ? 7 : 0,
                })
                setSelectedItemEmptyList([])
                setSelectedItemPRList([])
              }}
              onSearch={e => supplierRefetch({ name: e })}
              placeholder='พิมพ์เพื่อค้นหา'
            >
              {
                supplierData.supplierList.data.list.map(v => <Select.Option key={v.id} value={v.id} name={v.name}>{v.name}</Select.Option>)
              }
            </Select>
          }
        </Col>
      </Row>
      <Row type='flex' gutter={16} align='middle' style={{ margin: '16px -8px 0 0' }}>
        <SelectWithLabel
          style={{ width: '35%', margin: '0 24px 0 0' }}
          title={{
            text: <SmallText bold>เลือกประเภทการชำระเงิน *</SmallText>,
            margin: '0 0 8px',
          }}
          select={{
            value: mutationVariables.paymentType,
            onChange: (value) => {
              setMutationVariables({
                ...mutationVariables,
                paymentType: value,
              })
            },
            style: { width: '100%' },
            options: [({ text: 'เงินสด', value: 'CASH' }), ({ text: 'เครดิต', value: 'CREDIT' })],
            // disabled: _.find(supplierListOption, v => v.value === selectedSupplier).paymentType !== supplierPaymentType[0],
          }}
        />
        <Div margin='0 24px 0 0'>
          <SmallText display='block' bold margin='0 0 8px'>วันที่สั่งซื้อ *</SmallText>
          <DatePicker value={mutationVariables.purchaseDate} format='DD/MM/YY' onChange={(date) => {
            setMutationVariables({
              ...mutationVariables,
              purchaseDate: date,
            })
          }} />
        </Div>
        <Div margin='0 24px 0 0'>
          <SmallText display='block' bold margin='0 0 8px'>วันที่กำหนดส่ง *</SmallText>
          <DatePicker value={mutationVariables.dueDate} format='DD/MM/YY' onChange={(date) => {
            setMutationVariables({
              ...mutationVariables,
              dueDate: date,
            })
          }} />
        </Div>
        <Div margin='0 24px 0 0'>
          <SmallText display='block' bold margin='0 0 8px'>วันที่กำหนดชำระ *</SmallText>
          <DatePicker value={mutationVariables.paymentDueDate} format='DD/MM/YY' onChange={(date) => {
            setMutationVariables({
              ...mutationVariables,
              paymentDueDate: date,
            })
          }} />
        </Div>
      </Row>
      {
        !isNil(mutationVariables?.supplierId)
        && (
          <>
            <Divider margin='40px 0' />
            <Input
              width='100%'
              placeholder='ค้นหาใบPR'
              margin='0 0 8px'
              value={searchPR}
              onChange={(e) => {
                setSearchPR(e.target.value)
                purchaseRequisitionRefetch({ refId: e.target.value, supplierId: mutationVariables?.supplierId })
              }}
            />
            <SmallText bold margin='0 0 8px'>รายการ PR ที่ยังไม่ได้สั่ง</SmallText>
            <Div margin='0 0 0'>
              <Div moreStyle={{ overflow: 'auto', maxHeight: '250px' }}>
                {
                  !_.isEmpty(prList)
                    ? prList.map((v, i) => <GroupRowSelect key={i} list={v} />)
                    : (
                      <div className='bg-white py-6 text-center'>
                        <SmallText bold>ไม่พบ PR</SmallText>
                      </div>
                    )
                }
              </Div>
            </Div>
            <Input
              width='100%'
              placeholder='ค้นหาสินค้าจากชื่อสินค้า'
              margin='20px 0 8px'
              value={searchInventory}
              onChange={(e) => {
                setSearchInventory(e.target.value)
                lowInventoryRefetch({ productName: e.target.value, supplierId: mutationVariables?.supplierId })
                inventoryRefetch({ productName: e.target.value, supplierId: mutationVariables?.supplierId })
              }}
            />
            {
              !_.isEmpty(almostEmptyList)
              && <Div>
                <SmallText bold margin={'20px 0 8px'}>สินค้าที่ใกล้หมด</SmallText>
                <Div moreStyle={{ overflow: 'auto', maxHeight: '250px' }}>
                  {
                    almostEmptyList.map(v => <GroupRowSelect key={`${v.items[0].id}`} list={v} />)
                  }
                </Div>
              </Div>
            }
            {
              !_.isEmpty(otherList)
              && <Div>
                <SmallText display='block' bold margin='20px 0 8px'>สินค้าอื่นๆในคลังสินค้า</SmallText>
                <Div moreStyle={{ overflow: 'auto', maxHeight: '250px' }}>
                  {
                    otherList.map((v, i) => <GroupRowSelect key={i} list={v} />)
                  }
                </Div>
              </Div>
            }
            {
              _.isEmpty(almostEmptyList) && _.isEmpty(otherList)
              && (
                <div className='mt-[20px] bg-white py-6 text-center'>
                  <SmallText bold>ไม่พบสินค้า</SmallText>
                </div>
              )
            }

            <Divider margin='40px 0' />
            {
              (!_.isEmpty(selectedItemEmptyList) || !_.isEmpty(selectedItemPRList))
              && <Div margin='0 0 0'>
                <Div margin='0 0 8px 38px' display='flex' alignItems='center'>
                  <SmallText style={{ width: '38%' }} bold margin='0 40px 0 0'>สินค้า</SmallText>
                  <SmallText style={{ width: '12%' }} bold margin='0 24px 0 0'>จำนวน *</SmallText>
                  <SmallText style={{ width: '13%' }} bold margin='0 24px 0 0'>ราคา / ชิ้น *</SmallText>
                  <SmallText style={{ width: '13%' }} bold margin='0 24px 0 0'>ส่วนลด / หน่วย</SmallText>
                  <SmallText textAlign='right' style={{ flexGrow: 1 }} bold dmargin='0 24px 0 0'>ราคาทั้งหมด</SmallText>
                </Div>
              </Div>
            }
            {
              !_.isEmpty(selectedItemPRList)
              && <Div margin='0 0 8px'>
                <SmallText bold margin='0 0 16px'>สรุปสินค้าจากใบ PR</SmallText>
                {
                  Object.keys(_.groupBy(selectedItemPRList, 'prNumber')).map(key => <Div key={key}>
                    <SmallText bold>{key}</SmallText>
                    {
                      _.groupBy(selectedItemPRList, 'prNumber')[key].map((n, i) => <InputRow
                        margin={i !== selectedItemPRList.length - 1 ? '0 0 16px' : '0'}
                        key={n.prItemId || n.inventoryOptionId}
                        data={n}
                        onChange={(value, keyChange, valueType) => {
                          const index = _.findIndex(selectedItemPRList, item => (item.prNumber === key && item.sku === n.sku))
                          if (!_.isNil(index) && !_.isUndefined(keyChange)) {
                            onInputRowChange('pr', value, keyChange, valueType, index)
                          }
                        }}
                        onDelete={() => {
                          const index = _.findIndex(selectedItemPRList, item => (item.prNumber === key && item.sku === n.sku))
                          onInputRowDelete('pr', index)
                        }}
                      />)
                    }
                  </Div>)
                }
                {
                  !_.isEmpty(selectedItemEmptyList)
                  && <Divider />
                }
              </Div>
            }
            {
              !_.isEmpty(selectedItemEmptyList)
              && <Div>
                <SmallText bold>สรุปสินค้าอื่นๆที่เลือก</SmallText>
                {
                  selectedItemEmptyList.map((v, i) => <InputRow
                    margin={i !== selectedItemEmptyList.length - 1 ? '0 0 16px' : '0'}
                    key={v.inventoryOptionId || v.sku}
                    data={v}
                    onChange={(value, key, valueType) => {
                      onInputRowChange('empty', value, key, valueType, i)
                    }}
                    onDelete={() => {
                      onInputRowDelete('empty', i)
                    }}
                  />)
                }
              </Div>
            }
            {
              (!_.isEmpty(selectedItemEmptyList) || !_.isEmpty(selectedItemPRList))
              && <Divider
                // color='#C2E2BF'
                margin='40px 0'
              />
            }
            <Div moreStyle={{ flexGrow: 1 }}>
              <SummaryPrice
                data={{
                  total: _.reduce(selectedItemEmptyList, (sum, n) => sum + (parseFloat(n.quantity) * parseFloat(n.buyPrice)), 0) + _.reduce(selectedItemPRList, (sum, n) => sum + (parseFloat(n.quantity) * parseFloat(n.buyPrice)), 0),
                  shipping: {
                    value: shippingCost,
                    customOnChange: (value) => {
                      setShippingCost(value)
                    },
                  },
                  discount: {
                    value: _.reduce(selectedItemEmptyList, (sum, n) => sum + (parseFloat(n.quantity || 1) * parseFloat(n.discount)), 0) + _.reduce(selectedItemPRList, (sum, n) => sum + (parseFloat(n.quantity || 1) * parseFloat(n.discount)), 0),
                    disabled: true,
                    type: discountType,
                  },
                  vat: {
                    value: mutationVariables?.vat || 0,
                    handleVatChange: vat => setMutationVariables({ ...mutationVariables, vat }),
                  },
                }}
              />
            </Div>
            <TextareaWithLabel
              margin='8px 0'
              onChange={e => setMutationVariables({ ...mutationVariables, remark: e.target.value })} title={{
                text: 'หมายเหตุ',
              }} textarea={{
                style: { width: '100%' },
                rows: 8,
                margin: '8px 0 0',
                defaultValue: isCreateMode ? undefined : infoData.remark, // to change
              }}
            />
            <Div margin='24px 0 0' width='100%' display='flex' justifyContent='space-between' alignItems='flex-start'>
              <SmallText bold>แนบเอกสาร</SmallText>
              <Uploader
                isMultiple
                sltye={{ border: '1px solid red' }}
                buttonText='คลิกเพื่อเลือกไฟล์'
                inverse={false}
                icon='fal fa-paperclip'
                onChange={(e) => {
                  setFileList(e)
                }}
                data={fileList}
              />
            </Div>
            {
              !_.isEmpty(existFileList)
              && <Div margin='18px 0 0'>
                <SmallText bold margin='0 0 8px'>เอกสารที่อัพโหลดแล้ว</SmallText>
                {
                  existFileList.map((v, i) => (
                    <Div key={v.id} display='flex' alignItems='flex-start' justifyContent='space-between' margin={i !== existFileList.length - 1 && '0 0 8px 0'}>
                      <TextLink href={v.url} target='_blank' style={{ width: '100%', maxWidth: '90%' }}>
                        <SmallText display='block' style={{ width: '100%', wordBreak: 'break-all' }}>{v.fileName}</SmallText>
                      </TextLink>
                      <Icon onClick={() => {
                        const newArray = [...existFileList]
                        _.remove(newArray, n => n.id === v.id)
                        setExistFileList(newArray)
                      }} margin='4px 0 0' icon='fal fa-times' cursor='pointer' />
                    </Div>
                  ))
                }
              </Div>
            }
            <Button
              loading={mutationLoading}
              text={isCreateMode ? 'สร้างใบสั่งซื้อ' : 'แก้ไขใบสั่งซื้อ'}
              disabled={_.isUndefined(mutationVariables.dueDate) || _.isEmpty(mutationVariables.dueDate)
                || _.isUndefined(mutationVariables.supplierId)
                || _.isUndefined(mutationVariables.paymentType)
                || (_.isEmpty(selectedItemPRList) && _.isEmpty(selectedItemEmptyList))
                || _.isUndefined(mutationVariables.companyType)
                || warehouseLoading || _.isEmpty(warehouseData)
                || _.isUndefined(mutationVariables.purchaseDate) || _.isEmpty(mutationVariables.purchaseDate)
                || _.isUndefined(mutationVariables.paymentDueDate) || _.isEmpty(mutationVariables.paymentDueDate)}
              icon={isCreateMode ? 'far fa-plus' : 'far fa-edit'}
              style={{ alignItems: 'center' }}
              width='fit-content'
              margin='20px auto'
              onClick={() => {
                doAction({
                  variables: isCreateMode ? {
                    ...mutationVariables,
                    vat: undefined,
                    vatType: (mutationVariables.vat || 0) > 0 ? 'VAT_7' : 'NO_VAT',
                    warehouseId: _.find(warehouseData.warehouseList.data.list, o => o.warehouseCode === (mutationVariables?.companyType === 'PADOONGRICH' ? '00001' : '00002')).id,
                    orderItemList: _.concat(
                      selectedItemEmptyList.map(
                        v => ({
                          ..._.pick(v, ['quantity', 'inventoryOptionId', 'buyPrice', 'salesPrice', 'discount']),
                          isVat: (mutationVariables.vat || 0) > 0,
                        }),
                      ),
                      selectedItemPRList.map(
                        v => ({
                          ..._.pick(v, ['quantity', 'inventoryOptionId', 'buyPrice', 'salesPrice', 'discount', 'prItemId']),
                          isVat: (mutationVariables.vat || 0) > 0,
                        }),
                      ),
                    ),
                    deliveryCost: parseFloat(shippingCost, 10),
                    files: fileList,
                  } : {
                    ...mutationVariables,
                    vat: undefined,
                    vatType: (mutationVariables.vat || 0) > 0 ? 'VAT_7' : 'NO_VAT',
                    id: parseInt(props.match.params.id, 10),
                    warehouseId: 4,
                    deliveryCost: parseFloat(shippingCost, 10),
                  },
                  refetchQueries: [{
                    query: PURCHASEORDERS,
                    variables: {
                      limit: 5, offset: 0, orderField: 'updatedAt', orderBy: 'DESC',
                    },
                  }],
                }).then((resp) => {
                  const KEY = isCreateMode ? 'CreatePurchaseOrder' : 'UpdatePurchaseOrder'
                  if (resp.data[KEY] && resp.data[KEY].success) {
                    message.success(resp.data[KEY].message)
                    history.push('/purchase-order')
                  } else message.error(resp.data[KEY].message)
                })
              }}
            />
          </>
        )
      }
    </Div >
  )
}

export default ({ props }) => {
  const isCreateMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const [doAction, { loading: mutationLoading }] = useMutation(isCreateMode ? CREATE_PURCHASE_ORDER : UPDATE_PURCHASE_ORDER)
  const { loading, data, error } = useQuery(PURCHASEORDER, { skip: isCreateMode, variables: { id: props.match.params.id } })

  return (
    <Div>
      {
        !loading
          ? !isCreateMode && _.isNull(data.PurchaseOrderInfo)
            ? <H4>ไม่พบ</H4>
            : <Render
              infoData={data}
              mutationLoading={mutationLoading}
              doAction={doAction}
              props={props}
              isCreateMode={isCreateMode}
            />
          : null
      }
    </Div>
  )
}
